import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';


bootstrapApplication(AppComponent, appConfig,)
  .catch((err) => console.error(err));

  if ('serviceWorker' in navigator && environment.production) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js') // must use root path
    .then((registration) => {
      console.log('Firebase SW registered:', registration);
    })
    .catch((err) => {
      console.error('Firebase SW registration failed:', err);
    });
}